/* ZOALIN_SIZE_GUIDE_MODAL_V1 */
(() => {
  const FULL_SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  const LOUNGE_SIZES = ['M', 'L', 'XL', '2XL', '3XL', '4XL'];

  const standardSet = {
    label: window.zaT("Two-Piece Tunic & Pants Set"),
    sizes: FULL_SIZES,
    sections: [
      { title: window.zaT("Top / Tunic"), rows: [
        [window.zaT("Shoulder"), [39, 40, 41, 43, 44, 45, 46, 48]],
        [window.zaT("Bust"), [99, 104, 109, 114, 119, 124, 129, 134]],
        [window.zaT("Waist"), [105, 110, 115, 120, 125, 130, 135, 140]],
        [window.zaT("Sleeve width"), [36, 38, 39, 41, 42, 44, 45, 47]],
        [window.zaT("Sleeve length"), [57, 58, 59, 59, 60, 60, 61, 62]],
        [window.zaT("Top length"), [103, 104, 106, 107, 109, 110, 112, 113]],
      ]},
      { title: 'Pants', rows: [
        [window.zaT("Elastic waist"), ['64-79', '68-83', '72-87', '76-91', '80-95', '84-99', '88-103', '92-107']],
        [window.zaT("Front rise"), [29, 30, 30, 31, 31, 32, 33, 33]],
        [window.zaT("Thigh"), [67, 69, 72, 74, 77, 79, 82, 84]],
        [window.zaT("Hip"), [98, 103, 108, 113, 118, 123, 128, 133]],
        [window.zaT("Pants length"), [100, 101, 102, 103, 104, 105, 106, 107]],
      ]},
    ],
  };

  const loungeSet = {
    label: window.zaT("Relaxed Shirt & Pants Set"),
    sizes: LOUNGE_SIZES,
    sections: [
      { title: window.zaT("Top / Shirt"), rows: [
        [window.zaT("Shoulder"), [43, 44, 45, 46, 48, 49]],
        [window.zaT("Bust"), [108, 113, 118, 123, 128, 133]],
        [window.zaT("Sleeve length"), [56, 57, 58, 59, 60, 61]],
        [window.zaT("Top length"), [73, 74, 75, 76, 77, 78]],
      ]},
      { title: 'Pants', rows: [
        [window.zaT("Elastic waist"), ['68-86', '72-90', '76-94', '80-98', '84-102', '88-106']],
        [window.zaT("Hip"), [104, 109, 114, 119, 124, 129]],
        [window.zaT("Thigh"), [66, 69, 72, 75, 78, 81]],
        [window.zaT("Pants length"), [99, 100, 101, 102, 103, 104]],
      ]},
    ],
  };

  const dress = {
    label: window.zaT("Maxi Dress / Abaya"),
    sizes: FULL_SIZES,
    sections: [{ title: window.zaT("Dress"), rows: [
      [window.zaT("Shoulder"), [38, 39, 40, 41, 42, 43, 44, 45]],
      [window.zaT("Bust"), [96, 101, 106, 111, 116, 121, 126, 131]],
      [window.zaT("Waist"), [104, 109, 114, 119, 124, 129, 134, 139]],
      [window.zaT("Sleeve width"), [35, 36, 38, 39, 41, 42, 44, 45]],
      [window.zaT("Sleeve length"), [57, 58, 59, 60, 61, 62, 63, 64]],
      [window.zaT("Dress length"), [138, 139, 140, 141, 142, 143, 144, 145]],
      [window.zaT("Hem sweep"), [148, 153, 158, 163, 168, 173, 178, 183]],
    ]}],
  };

  const gatheredAbaya = {
    label: window.zaT("Gathered Abaya Maxi Dress"),
    sizes: FULL_SIZES,
    sections: [{ title: window.zaT("Abaya"), rows: [
      [window.zaT("Shoulder"), [38, 39, 40, 41, 42, 43, 44, 45]],
      [window.zaT("Bust"), [96, 101, 106, 111, 116, 121, 126, 131]],
      [window.zaT("Waist"), [104, 109, 114, 119, 124, 129, 134, 139]],
      [window.zaT("Sleeve width"), [35, 36, 38, 39, 41, 42, 44, 45]],
      [window.zaT("Sleeve length"), [57, 58, 59, 60, 61, 62, 63, 64]],
      [window.zaT("Dress length"), [139, 140, 141, 142, 143, 144, 145, 146]],
      [window.zaT("Hem sweep"), [162, 168, 174, 180, 186, 192, 198, 204]],
    ]}],
  };

  const openAbaya = {
    label: window.zaT("Open Abaya & Inner Dress"),
    sizes: FULL_SIZES,
    sections: [{ title: window.zaT("Open Abaya"), rows: [
      [window.zaT("Shoulder"), [39, 40, 41, 42, 43, 44, 45, 46]],
      [window.zaT("Bust"), [100, 105, 110, 115, 120, 125, 130, 135]],
      [window.zaT("Sleeve length"), [58, 59, 60, 61, 62, 63, 64, 65]],
      [window.zaT("Outer length"), [140, 141, 142, 143, 144, 145, 146, 147]],
      [window.zaT("Inner length"), [136, 137, 138, 139, 140, 141, 142, 143]],
      [window.zaT("Hem sweep"), [150, 156, 162, 168, 174, 180, 186, 192]],
    ]}],
  };

  const GUIDES = {
    'floral-a-line-maxi-dress': {"label":"Floral A-Line Maxi Dress","sizes":["S","M","L","XL","2XL","3XL","4XL","5XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Dress","rows":[["Shoulder",[39,40,41,43,44,45,46,48]],["Bust",[95,100,105,110,115,120,125,130]],["Waist",[85,90,95,100,105,110,115,120]],["Sleeve width",[37,38,40,41,43,44,46,47]],["Sleeve length",[58,59,60,60,61,61,62,63]],["Dress length",[133,135,137,139,141,143,145,147]]]}]},
    'panelled-tunic-pants-set': {"label":"Panelled Tunic & Pants Set","sizes":["S","M","L","XL","2XL","3XL","4XL","5XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Top","rows":[["Shoulder",[39,40,41,43,44,45,46,48]],["Bust",[97,102,107,112,117,122,127,132]],["Sleeve width",[37,38,40,41,43,44,46,47]],["Sleeve length",[57,58,59,59,60,60,61,62]],["Top length",[88,89,90,91,93,94,95,96]]]},{"title":"Pants","rows":[["Waist",["64–79","68–83","72–87","76–91","80–95","84–99","88–103","92–107"]],["Front rise",[32,33,34,34,35,35,36,37]],["Back rise",[41,42,42,43,44,45,45,46]],["Thigh",[64,67,70,72,75,78,81,83]],["Hip",[101,106,111,116,121,126,131,136]],["Pants length",[102,103,105,106,108,109,111,112]]]}]},
    'contrast-trim-tunic-pants-set': {"label":"Contrast-Trim Tunic & Pants Set","sizes":["S","M","L","XL","2XL","3XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Top","rows":[["Bust",[93,98,103,108,113,118]],["Top length",[101,102,104,105,107,108]],["Sleeve length",[59,60,61,61,62,62]]]},{"title":"Pants","rows":[["Waist",["66–81","70–85","74–89","78–93","82–97","86–101"]],["Front rise",[32,33,34,34,35,35]],["Back rise",[42,43,43,44,45,46]],["Hip",[102,107,112,117,122,127]],["Pants length",[101,102,104,105,107,108]]]}]},
    'embroidered-placket-tunic-pants-set': {"label":"Embroidered Placket Tunic & Pants Set","sizes":["S","M","L","XL","2XL","3XL","4XL","5XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Top","rows":[["Shoulder",[39,44,49,54,59,64,69,74]],["Bust",[93,98,103,108,113,118,123,128]],["Armhole",[36,37,39,40,42,43,45,46]],["Sleeve length",[59,60,61,61,62,62,63,64]],["Top length",[97,98,100,101,103,104,106,107]]]},{"title":"Pants","rows":[["Waist",["64–74","68–78","72–82","76–86","80–90","84–94","88–98","92–102"]],["Hip",[101,106,111,116,121,126,131,136]],["Pants length",[101,102,104,105,107,108,110,111]]]}]},
    'eyelet-tiered-maxi-dress': {"label":"Eyelet Tiered Maxi Dress","sizes":["S","M","L","XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Dress","rows":[["Shoulder",[37,38,39.5,41]],["Bust",[98,102,108,114]],["Waist",[98,102,108,114]],["Dress length",[129,130,131,132]],["Sleeve length",[43,44,45,46]],["Armhole",[33.6,35,37.2,39.4]]]}]},
    'textured-rosette-shirt-pants-set': {"label":"Textured Rosette Shirt & Pants Set","sizes":["S","M","L","XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Top","rows":[["Bust",[108,112,116,120]],["Sleeve length",[53,54,55,56]],["Shoulder",[44,44.5,45,45.5]],["Top length",[65,66,67,68]]]},{"title":"Pants","rows":[["Pants length",[97,98,99,100]],["Waist",["60–88","62–92","64–96","66–100"]]]}]},
    'textured-tie-waist-shirt-pants-set': {"label":"Textured Tie-Waist Shirt & Pants Set","sizes":["S","M","L","XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Top","rows":[["Bust",[108,112,116,122]],["Sleeve length",[53,54,55,56]],["Shoulder",[41,42,43,44]],["Top length",[66,67,68,69]]]},{"title":"Pants","rows":[["Pants length",[99,100,101,102]],["Waist",["58–106","60–110","62–114","64–118"]]]}]},
    'asymmetric-button-tunic-pants-set': {"label":"Asymmetric Button Tunic & Pants Set","sizes":["S","M","L","XL","2XL","3XL","4XL","5XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Top","rows":[["Shoulder",[39,40,41,43,44,45,46,48]],["Bust",[95,100,105,110,115,120,125,130]],["Armhole",[38,40,41,43,44,46,47,49]],["Sleeve length",[50,51,52,52,53,53,54,55]],["Top length",[110,111,113,114,116,117,119,120]]]},{"title":"Pants","rows":[["Waist",["66–76","70–80","74–84","78–88","82–92","86–96","90–100","94–104"]],["Hip",[100,105,110,115,120,125,130,135]],["Front rise",[32,33,33,34,34,35,36,36]],["Back rise",[43,44,44,45,46,46,47,48]],["Pants length",[95,96,98,99,101,102,104,105]]]},{"title":"Size conversion","dimensionless":true,"unitLabel":"US / CA / UK / AU","rows":[["US / CA",["S","M","L","XL","2XL","3XL","4XL","5XL"]],["UK / AU",[8,"10–12",14,16,18,20,22,24]]]}]},
    'printed-tiered-maxi-dress': {"label":"Printed Tiered Maxi Dress","sizes":["S","M","L","XL","2XL","3XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Dress","rows":[["Shoulder",[38,39,40,42,43,44]],["Bust",[96,101,106,111,116,121]],["Sleeve length",[59,60,61,61,62,62]],["Dress length",[137,138,140,141,143,144]]]}]},
    'ditsy-floral-maxi-dress': {"label":"Ditsy Floral Maxi Dress","sizes":["S","M","L","XL","2XL","3XL","4XL","5XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Dress","rows":[["Shoulder",[39,41,42,43,44,46,47,48]],["Bust",[95,100,105,110,115,120,125,130]],["Waist",[93,98,103,108,113,118,123,128]],["Sleeve length",[55,56,57,57,58,58,59,60]],["Dress length",[133,135,137,139,141,143,145,147]]]},{"title":"Size equivalents","unitLabel":"US/CA / UK / AU","dimensionless":true,"rows":[["US/CA",["S","M","L","XL","2XL","3XL","4XL","5XL"]],["UK",[8,"10–12",14,16,18,20,22,24]],["AU",[8,"10–12",14,16,18,20,22,24]]]}]},
    'floral-sleeve-abaya': {"label":"Floral Sleeve Abaya","sizes":["S","M","L","XL","2XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Abaya","rows":[["Shoulder",[39,40,41,43,44]],["Bust",[95,100,105,110,115]],["Waist",[121,126,131,136,141]],["Armhole",[35,36,38,39,41]],["Sleeve length",[59,60,61,61,62]],["Dress length",[138,140,142,144,146]]]},{"title":"Size equivalents","unitLabel":"US/CA / UK / AU","dimensionless":true,"rows":[["US/CA",["S","M","L","XL","2XL"]],["UK",[8,"10–12",14,16,18]],["AU",[8,"10–12",14,16,18]]]}]},
    'gold-floral-abaya': {"label":"Gold Floral Abaya","sizes":["S","M","L","XL","2XL"],"note":"Finished garment measurements. Bust is the full circumference. Allow 1–3 cm variation from manual measurement.","sections":[{"title":"Abaya","rows":[["Shoulder",[40,41,42,44,45]],["Bust",[95,100,105,110,115]],["Waist",[98,103,108,113,118]],["Armhole",[35,36,38,39,41]],["Sleeve length",[57,58,59,59,60]],["Dress length",[136,138,140,142,144]]]},{"title":"Size equivalents","unitLabel":"US/CA / UK / AU / RU","dimensionless":true,"rows":[["US/CA",["S","M","L","XL","2XL"]],["UK",[8,"10–12",14,16,18]],["AU",[8,"10–12",14,16,18]],["RU",[44,46,48,50,52]]]}]},
    'zip-front-abaya': {label: 'Zip-Front Abaya', sizes: ['XS','S','M','L','XL','2XL','3XL','4XL','5XL'], note: 'Finished garment measurements. Bust is the full circumference. Between sizes, we recommend sizing up. Allow 1–3 cm variation from manual measurement.', sections: [{title: window.zaT("Abaya"), rows: [[window.zaT("Shoulder"),[39,40,41,42,43,44,45,46,47]],[window.zaT("Bust"),[94,100,106,112,118,124,130,136,142]],[window.zaT("Waist"),[101,107,113,119,125,131,137,143,149]],[window.zaT("Sleeve length"),[62.5,63,63.5,64,64.5,65,65.5,66,66.5]],[window.zaT("Dress length"),[134,136,137,138,139,140,141,142,143]]]}]},
    'pleated-abaya': {label: 'Pleated Abaya', sizes: FULL_SIZES, note: 'Finished garment measurements. Bust is the full circumference. Waist figures are for reference only, not actual measurements. Allow 1–3 cm variation from manual measurement.', sections: [{title: window.zaT("Abaya"), rows: [[window.zaT("Shoulder"),[38,40,41,42,43,45,46,47]],[window.zaT("Bust"),[95,100,105,110,115,120,125,130]],['Waist*',[99,104,109,114,119,124,129,134]],[window.zaT("Sleeve width"),[36,37,39,40,42,43,45,46]],[window.zaT("Sleeve length"),[59,60,61,61,62,62,63,64]],[window.zaT("Dress length"),[134,136,138,140,142,144,146,148]]]},{title:'Size equivalents',dimensionless:true,rows:[['UK size',[8,'10–12',14,16,18,20,22,24]],['AU size',[8,'10–12',14,16,18,20,22,24]]]}]},

    'floral-embroidered-abaya': {label: window.zaT("Abaya"), sizes: ['S','M','L','XL','2XL'], sections: [{title: window.zaT("Abaya"), rows: [[window.zaT("Shoulder"),[39,40,41,42,43]],[window.zaT("Bust"),[103,107,111,115,119]],[window.zaT("Sleeve length"),[58,59,60,61,62]],[window.zaT("Dress length"),[132,134,136,138,140]]]}]},

    'everyday-modest-tunic-set': standardSet,
    'soft-layered-modest-set': standardSet,
    'printed-flow-maxi-dress': standardSet,
    'abstract-print-tunic-pants-set': standardSet,
    'graceful-button-maxi-dress': dress,
    'abstract-print-maxi-dress': dress,
    'soft-pleated-abaya-dress': gatheredAbaya,
    'relaxed-modest-lounge-set': loungeSet,
    'elegant-open-abaya': openAbaya,
    'tailored-modest-two-piece-set': standardSet,
    'everyday-tunic-and-pants-set': standardSet,
  };

  let root = null;
  let dialog = null;
  let guide = null;
  let unit = 'cm';
  let selectedSize = '';
  let returnFocus = null;
  let pickerSize = null;
  let parentPicker = null;

  const normalizeSize = (value) => String(value || '').trim().toUpperCase().replace(/\s+/g, '');
  const formatInches = (number) => {
    const value = Math.round((Number(number) / 2.54) * 10) / 10;
    return Number.isInteger(value) ? String(value) : value.toFixed(1);
  };
  const convertValue = (value) => {
    const parts = String(value).split(/\s*[-–]\s*/);
    if (parts.length === 2 && parts.every((part) => /^\d+(\.\d+)?$/.test(part))) {
      return parts.map(formatInches).join('–');
    }
    return /^\d+(\.\d+)?$/.test(String(value)) ? formatInches(value) : String(value);
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = window.zaT(text);
    return node;
  };

  const renderTables = () => {
    if (!root || !guide) return;
    const container = root.querySelector('[data-zoalin-size-tables]');
    container.replaceChildren();
    guide.sections.forEach((section) => {
      const wrapper = element('section', 'zoalin-size-guide__table-section');
      const heading = element('div', 'zoalin-size-guide__table-title');
      heading.append(element('h3', '', window.zaT(section.title)), element('span', '', section.dimensionless ? (section.unitLabel || 'UK / AU') : (unit === 'cm' ? window.zaT("All measurements in cm") : window.zaT("All measurements in inches"))));
      const scroll = element('div', 'zoalin-size-guide__scroll');
      scroll.tabIndex = 0;
      scroll.setAttribute('aria-label', window.zaT(section.title) + window.zaT(" size chart. Scroll horizontally to see all sizes."));
      const table = document.createElement('table');
      const thead = document.createElement('thead');
      const headRow = document.createElement('tr');
      headRow.append(element('th', '', window.zaT("Measurement")));
      guide.sizes.forEach((size) => {
        const th = element('th', '', size);
        th.dataset.size = normalizeSize(size);
        th.scope = 'col';
        headRow.append(th);
      });
      thead.append(headRow);
      const tbody = document.createElement('tbody');
      section.rows.forEach(([label, values]) => {
        const row = document.createElement('tr');
        const labelCell = element('td', '', label);
        row.append(labelCell);
        values.forEach((value, index) => {
          const cell = element('td', '', unit === 'cm' || section.dimensionless ? String(value) : convertValue(value));
          cell.dataset.size = normalizeSize(guide.sizes[index]);
          cell.dataset.cm = String(value);
          row.append(cell);
        });
        tbody.append(row);
      });
      table.append(thead, tbody);
      scroll.append(table);
      wrapper.append(heading, scroll);
      container.append(wrapper);
    });
    if (guide.note) container.append(element('p', 'zoalin-size-guide__note', guide.note));
    highlightSelectedSize();
  };

  const readSelectedSize = () => {
    if(pickerSize!==null)return pickerSize;
    const handle = root?.dataset.productHandle || '';
    const picker = document.querySelector('variant-picker[data-product-handle="' + CSS.escape(handle) + '"]') || document.querySelector('variant-picker');
    if (picker) {
      const checked = Array.from(picker.querySelectorAll('input[data-option-name]:checked')).find((input) => /size/i.test(input.dataset.optionName || ''));
      if (checked?.value) return checked.value;
      const select = Array.from(picker.querySelectorAll('select')).find((node) => {
        const option = node.selectedOptions?.[0];
        return /size/i.test(option?.dataset.optionName || node.name || '');
      });
      if (select?.value) return select.value;
    }
    const customSelect = document.querySelector('[data-za-variant-select][data-size-option-index]');
    const customSize = customSelect?.selectedOptions?.[0]?.dataset?.sizeValue;
    if (customSize) return customSize;
    return root?.dataset.initialSize || '';
  };

  const highlightSelectedSize = () => {
    if (!root || !guide) return;
    selectedSize = readSelectedSize() || selectedSize;
    const normalized = normalizeSize(selectedSize);
    root.querySelectorAll('[data-size]').forEach((cell) => cell.classList.toggle('is-current', cell.dataset.size === normalized));
    const note = root.querySelector('[data-zoalin-size-selected]');
    if (normalized && guide.sizes.some((size) => normalizeSize(size) === normalized)) {
      note.textContent = window.zaT("Currently selected: ") + selectedSize;
      note.hidden = false;
    } else {
      note.hidden = true;
    }
  };

  const setUnit = (nextUnit) => {
    unit = nextUnit === 'in' ? 'in' : 'cm';
    root.querySelectorAll('[data-zoalin-size-unit]').forEach((button) => {
      const active = button.dataset.zoalinSizeUnit === unit;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    renderTables();
  };

  const open = (trigger) => {
    if (!root || !guide) return;
    const handle=trigger?.dataset.guideHandle||root.dataset.productHandle;
    guide=GUIDES[handle]||standardSet;
    pickerSize=trigger?.hasAttribute('data-guide-size')?trigger.dataset.guideSize:null;
    selectedSize=pickerSize||'';
    root.querySelector('[data-zoalin-size-guide-product]').textContent=window.zaT(guide.label);
    setUnit('cm');
    returnFocus = trigger || document.activeElement;
    parentPicker=trigger?.closest('[data-za-quick-add-picker],[data-wishlist-picker]');
    if(parentPicker){parentPicker.inert=true;parentPicker.setAttribute('aria-hidden','true');}
    highlightSelectedSize();
    root.hidden = false;
    document.body.classList.add('zoalin-size-guide-open');
    dialog.focus();
  };
  const close = () => {
    if (!root || root.hidden) return;
    root.hidden = true;
    document.body.classList.remove('zoalin-size-guide-open');
    if(parentPicker){parentPicker.inert=false;parentPicker.removeAttribute('aria-hidden');parentPicker=null;}
    if (returnFocus?.focus) returnFocus.focus();
  };

  const initialize = () => {
    root = document.querySelector('[data-zoalin-size-guide]');
    if (!root) return;
    dialog = root.querySelector('.zoalin-size-guide__dialog');
    guide = GUIDES[root.dataset.productHandle] || standardSet;
    root.querySelector('[data-zoalin-size-guide-product]').textContent = guide.label;
    selectedSize = root.dataset.initialSize || '';
    setUnit('cm');

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-zoalin-size-guide-open]');
      if (trigger) {
        event.preventDefault();
        open(trigger);
        return;
      }
      if (event.target.closest('[data-zoalin-size-guide-close]')) {
        event.preventDefault();
        close();
        return;
      }
      const unitButton = event.target.closest('[data-zoalin-size-unit]');
      if (unitButton) setUnit(unitButton.dataset.zoalinSizeUnit);
      if (event.target.closest('variant-picker')) window.setTimeout(highlightSelectedSize, 50);
    });
    document.addEventListener('change', (event) => {
      if (event.target.closest('variant-picker')) window.setTimeout(highlightSelectedSize, 0);
      if (event.target.closest('[data-za-variant-select]')) window.setTimeout(highlightSelectedSize, 0);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) {event.preventDefault();event.stopImmediatePropagation();close();}
      if (event.key === 'Tab' && !root.hidden) {
        const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    },true);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
